module.exports = __webpack_public_path__ + "img/quest_icon_0037_hit.cce59554.png";